// import React, { useState } from 'react';
// import UserManagementHeader from './UserManagementHeader';
// import UserSearchBar from './UserSearchBar';
// import UserTable from './UserTable';
// import UserPagination from './UserPagination';
// import UserFormSlider from './UserFormSlider';
// import UserHistoryModal from './UserHistoryModal';
// import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
// import styles from './UserManagement.module.css';
// import { useUserManagement } from './Hooks/useUserManagement';

// const UserManagement = () => {
//     const {
//         users,
//         roles,
//         studies,
//         sites,
//         consentTemplates,
//         searchTerm,
//         setSearchTerm,
//         currentPage,
//         setCurrentPage,
//         rowsPerPage,
//         setRowsPerPage,
//         totalPages,
//         totalRecords,
//         loading,
//         confirmModal,
//         setConfirmModal,
//         handleCreateUser,
//         handleUpdateUser,
//         handleDeleteUser,
//         fetchUserHistory
//     } = useUserManagement();

//     const [showCreateSlider, setShowCreateSlider] = useState(false);
//     const [showEditSlider, setShowEditSlider] = useState(false);
//     const [showHistoryModal, setShowHistoryModal] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);
//     const [expandedUserId, setExpandedUserId] = useState(null);

//     const handleEdit = (user) => {
//         setSelectedUser(user);
//         setShowEditSlider(true);
//     };

//     const handleDelete = (user) => {
//         setConfirmModal({
//             show: true,
//             title: 'Delete User',
//             message: `Are you sure you want to permanently delete ${user.full_name}? This action cannot be undone and will remove all user data.`,
//             type: 'delete',
//             confirmText: 'Delete Permanently',
//             cancelText: 'Cancel',
//             onConfirm: () => {
//                 setConfirmModal(prev => ({ ...prev, show: false }));
//                 handleDeleteUser(user);
//             },
//             onCancel: () => setConfirmModal(prev => ({ ...prev, show: false }))
//         });
//     };

//     const handleHistory = (user) => {
//         setSelectedUser(user);
//         setShowHistoryModal(true);
//     };

//     const handleSearchChange = (e) => {
//         setSearchTerm(e.target.value);
//         setCurrentPage(1);
//     };

//     const handleRowsPerPageChange = (e) => {
//         setRowsPerPage(Number(e.target.value));
//         setCurrentPage(1);
//     };

//     const toggleRow = (userId) => {
//         setExpandedUserId(prev => prev === userId ? null : userId);
//     };

//     return (
//         <div className={styles.container}>
//             <UserManagementHeader onCreateClick={() => setShowCreateSlider(true)} />

//             <UserSearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange} />

//             <div className={styles.tableWrapper}>
//                 <UserTable
//                     users={users}
//                     loading={loading}
//                     onEdit={handleEdit}
//                     onDelete={handleDelete}
//                     onHistory={handleHistory}
//                     expandedUserId={expandedUserId}
//                     onToggleRow={toggleRow}
//                 />
//             </div>

//             <UserPagination
//                 currentPage={currentPage}
//                 totalPages={totalPages}
//                 rowsPerPage={rowsPerPage}
//                 totalRecords={totalRecords}
//                 onPageChange={setCurrentPage}
//                 onRowsPerPageChange={handleRowsPerPageChange}
//             />

//             <UserFormSlider
//                 show={showCreateSlider}
//                 mode="create"
//                 roles={roles}
//                 studies={studies}
//                 sites={sites}
//                 consentTemplates={consentTemplates}
//                 onClose={() => setShowCreateSlider(false)}
//                 onSubmit={handleCreateUser}
//             />

//             <UserFormSlider
//                 show={showEditSlider}
//                 mode="edit"
//                 user={selectedUser}
//                 roles={roles}
//                 studies={studies}
//                 sites={sites}
//                 consentTemplates={consentTemplates}
//                 onClose={() => setShowEditSlider(false)}
//                 onSubmit={handleUpdateUser}
//             />

//             <UserHistoryModal
//                 show={showHistoryModal}
//                 user={selectedUser}
//                 onClose={() => setShowHistoryModal(false)}
//                 onFetchHistory={fetchUserHistory}
//             />

//             <ConfirmationModal
//                 show={confirmModal.show}
//                 title={confirmModal.title}
//                 message={confirmModal.message}
//                 type={confirmModal.type}
//                 confirmText={confirmModal.confirmText}
//                 cancelText={confirmModal.cancelText}
//                 onConfirm={confirmModal.onConfirm}
//                 onCancel={confirmModal.onCancel}
//             />
//         </div>
//     );
// };

// export default UserManagement;

import React, { useState } from 'react';
import UserManagementHeader from './UserManagementHeader';
import UserSearchBar from './UserSearchBar';
import UserTable from './UserTable';
import UserPagination from './UserPagination';
import UserFormSlider from './UserFormSlider';
import UserHistoryModal from './UserHistoryModal';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import styles from './UserManagement.module.css';
import { useUserManagement } from './Hooks/useUserManagement';

const UserManagement = () => {
    const {
        users,
        roles,
        studies,
        sites,
        consentTemplates,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalPages,
        totalRecords,
        loading,
        confirmModal,
        setConfirmModal,
        handleCreateUser,
        handleUpdateUser,
        handleDeleteUser,
        fetchUserHistory
    } = useUserManagement();

    const [showCreateSlider, setShowCreateSlider] = useState(false);
    const [showEditSlider, setShowEditSlider] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [expandedUserId, setExpandedUserId] = useState(null);

    const handleEdit = (user) => {
        const isPrincipalInvestigator = user.role_name === 'Principal Investigator' || String(user.role_id) === '2';

        if (isPrincipalInvestigator && user.study_id) {
            const transformedUser = {
                user_id: user.user_id,
                full_name: user.full_name,
                email_address: user.email_address,
                contact_number: user.contact_number,
                role_id: user.role_id,
                role_name: user.role_name,
                status: user.status,
                assigned_sites: [{
                    study_id: user.study_id || '',
                    study_number: user.study_number || '',
                    study_name: user.study_title || '',
                    site_id: user.site_id || '',
                    site_code: user.site_code || '',
                    site_name: user.site_name || '',
                    max_subjects: String(user.max_subjects || '20'),
                    currency: user.currency || 'USD',
                    service_fee: String(user.service_fee || ''),
                    consent_template_id: user.consent_template_id || '',
                    consent_template: user.consent_template || ''
                }]
            };

            setSelectedUser(transformedUser);
        } else {
            setSelectedUser(user);
        }

        setShowEditSlider(true);
    };

    const handleDelete = (user) => {
        setConfirmModal({
            show: true,
            title: 'Delete User',
            message: `Are you sure you want to permanently delete ${user.full_name}? This action cannot be undone and will remove all user data.`,
            type: 'delete',
            confirmText: 'Delete Permanently',
            cancelText: 'Cancel',
            onConfirm: () => {
                setConfirmModal(prev => ({ ...prev, show: false }));
                handleDeleteUser(user);
            },
            onCancel: () => setConfirmModal(prev => ({ ...prev, show: false }))
        });
    };

    const handleHistory = (user) => {
        setSelectedUser(user);
        setShowHistoryModal(true);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const toggleRow = (userId) => {
        setExpandedUserId(prev => prev === userId ? null : userId);
    };

    return (
        <div className={styles.container}>
            <UserManagementHeader onCreateClick={() => setShowCreateSlider(true)} />

            <UserSearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange} />

            <div className={styles.tableWrapper}>
                <UserTable
                    users={users}
                    loading={loading}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onHistory={handleHistory}
                    expandedUserId={expandedUserId}
                    onToggleRow={toggleRow}
                />
            </div>

            <UserPagination
                currentPage={currentPage}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRecords}
                onPageChange={setCurrentPage}
                onRowsPerPageChange={handleRowsPerPageChange}
            />

            <UserFormSlider
                show={showCreateSlider}
                mode="create"
                roles={roles}
                studies={studies}
                sites={sites}
                consentTemplates={consentTemplates}
                onClose={() => setShowCreateSlider(false)}
                onSubmit={handleCreateUser}
            />

            <UserFormSlider
                show={showEditSlider}
                mode="edit"
                user={selectedUser}
                roles={roles}
                studies={studies}
                sites={sites}
                consentTemplates={consentTemplates}
                onClose={() => {
                    setShowEditSlider(false);
                    setSelectedUser(null);
                }}
                onSubmit={handleUpdateUser}
            />

            <UserHistoryModal
                show={showHistoryModal}
                user={selectedUser}
                onClose={() => setShowHistoryModal(false)}
                onFetchHistory={fetchUserHistory}
            />

            <ConfirmationModal
                show={confirmModal.show}
                title={confirmModal.title}
                message={confirmModal.message}
                type={confirmModal.type}
                confirmText={confirmModal.confirmText}
                cancelText={confirmModal.cancelText}
                onConfirm={confirmModal.onConfirm}
                onCancel={confirmModal.onCancel}
            />
        </div>
    );
};

export default UserManagement;